import AccessLevelTabs from "./AccessLevelTabs";
import FormField from "./FormField";
import ProjectSelect from "./ProjectSelect";
import UserMultiSelect from "./UserMultiSelect";
import type { MCPSharingUserItem } from "../../../services/agent-tools-service";
import type { AccessLevel } from "../types";
import { useTranslation } from "react-i18next";

type Props = {
  accessLevel: AccessLevel;
  onAccessLevelChange: (level: AccessLevel) => void;
  projectId: string;
  onProjectIdChange: (id: string) => void;
  users: MCPSharingUserItem[];
  onUsersChange: (users: MCPSharingUserItem[]) => void;
  requireCurrentUser?: boolean;
};

const AccessLevelField = ({
  accessLevel,
  onAccessLevelChange,
  projectId,
  onProjectIdChange,
  users,
  onUsersChange,
  requireCurrentUser = false,
}: Props) => {
  const { t } = useTranslation();
  const showProjects = accessLevel === "project";
  const showUsers = accessLevel === "user";
  return (
    <div className="flex flex-col gap-2">
      <FormField label={t("mcpPage.fields.accessLevel")} compact>
        <AccessLevelTabs value={accessLevel} onChange={onAccessLevelChange} />
      </FormField>

      {showProjects && (
        <FormField label={t("mcpPage.fields.project")} compact>
          <ProjectSelect
            value={projectId}
            onChange={onProjectIdChange}
            triggerClassName="h-9"
          />
        </FormField>
      )}

      {showUsers && (
        <FormField label={t("mcpPage.fields.users")} compact>
          <UserMultiSelect
            value={users}
            onChange={onUsersChange}
            requireCurrentUser={requireCurrentUser}
            triggerClassName="h-9"
          />
        </FormField>
      )}
    </div>
  );
};

export default AccessLevelField;
